//
// Module for the Salary History Index view
//
rs.module("content/participant/member/salaryhistory/index",

    ["controls/data/grid"],

    function (gridModule) {

        function initialize(lrsGridApi, jsSelectors, backendUrl) {
            var filter = $.js(jsSelectors.filter);
            var includeCancelledCheckBox = filter.js(jsSelectors.includeCancelledCheckBox);
            var loadingSpinner = filter.js(jsSelectors.loadingSpinner);

            includeCancelledCheckBox.change(includeCancelledChanged);

            /**
             * Hookup Ajax to changed checkbox selection
             */
            function includeCancelledChanged() {
                loadingSpinner.show();
                gridModule.update(
                    backendUrl,

                    { includeCancelled: includeCancelledCheckBox.is(':checked') },

                    lrsGridApi.agGridApi,

                    function done() {
                        loadingSpinner.hide();
                    }
                );
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);